export default __webpack_public_path__ + "static/jesse-martin-d2aed0afc2a92e50d4c26b989296503a.png";